const en = {
    authorization: {
        invalid_credentials: 'Please check your entered password',
        user: {
            not_found: 'Please check your entered email'
        },
        register: {
            title: 'SIGN UP WITH BOXITI',
            subtitle: 'Focus on business development and strategic decisions while leaving orders fulfilment for us'
        },
        login: {
            title: 'LOG IN',
            subtitle: 'Log in to the personal Boxiti user environment',
            card_title: 'Login',
            placeholder: {
                email: 'E-mail',
                password: 'Password'
            },
            btn_login: 'Log in',
            stay_in: 'Stay signed in',
            password_reminder: 'Pasword reminder',
            create_account: 'Create a new account'
        },
        reset_password: {
            title: 'Reset your <br>password',
            subtitle: ''
        }
    }
}

const lt = {
    authorization: {
        invalid_credentials: 'Please check your entered password',
        user: {
            not_found: 'Please check your entered email'
        },
        register: {
            title: 'SIGN UP WITH BOXITI',
            subtitle: 'Focus on business development and strategic decisions while leaving orders fulfilment for us'
        },
        login: {
            title: 'PRISIJUNGIMAS',
            subtitle: 'Prisijunkite prie asmeninės Boxiti vartotojo aplinkos',
            card_title: 'Prisijungimas',
            placeholder: {
                email: 'El. paštas',
                password: 'Slaptažodis'
            },
            btn_login: 'Prisijungti',
            stay_in: 'Likti prisijungus',
            password_reminder: 'Slaptažodžio priminimas',
            create_account: 'Sukurti naujo vartotojo aplinką'
        },
        reset_password: {
            title: 'Reset your <br>password',
            subtitle: ''
        }
    }
}

export default {en, lt}



// WEBPACK FOOTER //
// ./src/i18n/authorization.js